import { useState } from 'react';

interface TrialBannerProps {
  daysRemaining: number;
  ideaCount?: number;
  /** Called when the trial-ended modal (daysRemaining <= 0) is dismissed. */
  onDismiss?: () => void;
}

export function TrialBanner({ daysRemaining, ideaCount, onDismiss }: TrialBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed && (daysRemaining > 1 || daysRemaining <= 0)) return null;

  // Expiration day: modal
  if (daysRemaining <= 0) {
    return (
      <div className="trial-modal-overlay">
        <div className="trial-modal">
          <h2 className="trial-modal-title">Your Pro trial has ended</h2>
          <p className="trial-modal-desc">
            Your account has been switched to the free plan.
            {ideaCount != null && ideaCount > 50 && (
              <> Your {ideaCount} ideas are safe — you just can&apos;t create new ones until you upgrade or are under 50.</>
            )}
          </p>
          <div className="trial-modal-still">
            <strong>You can still:</strong>
            <ul>
              <li>View and edit all existing ideas</li>
              <li>Use keyword search and 10 semantic searches/month</li>
              <li>View the mind map and idea relations</li>
              <li>Use kanban board and export data</li>
              <li>Capture via web, MCP, CLI, and Claude Code</li>
            </ul>
          </div>
          <a href="/upgrade" className="btn btn-primary trial-modal-cta">
            Upgrade to Pro — $7/mo
          </a>
          <button className="btn btn-ghost trial-modal-dismiss" onClick={() => { setDismissed(true); onDismiss?.(); }}>
            Continue with free plan
          </button>
        </div>
      </div>
    );
  }

  // 1 day remaining: prominent banner
  if (daysRemaining <= 1) {
    return (
      <div className="trial-ending-banner trial-ending-urgent">
        Your Pro trial ends tomorrow.{' '}
        {ideaCount != null && <span>You have {ideaCount} ideas. The free plan includes 50. </span>}
        <a href="/upgrade">Upgrade to keep Pro features &rarr;</a>
      </div>
    );
  }

  // 5 days or fewer: dismissable banner
  return (
    <div className="trial-ending-banner">
      Your Pro trial ends in {daysRemaining} day{daysRemaining !== 1 ? 's' : ''}.{' '}
      {ideaCount != null && <span>You have {ideaCount} ideas. The free plan includes 50. </span>}
      <a href="/upgrade">Upgrade to keep Pro features &rarr;</a>
      <button className="trial-banner-dismiss" onClick={() => setDismissed(true)}>&times;</button>
    </div>
  );
}
